import { render } from "./PassingLinkRenderer.vue?vue&type=template&id=10feeecb&scoped=true"
import script from "./PassingLinkRenderer.vue?vue&type=script&lang=js"
export * from "./PassingLinkRenderer.vue?vue&type=script&lang=js"

import "./PassingLinkRenderer.vue?vue&type=style&index=0&id=10feeecb&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10feeecb"]])

export default __exports__